import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { accountRoute } from '../../routes';

import baseUrl from '../../utils/baseUrl';

import Dropdown from '../../components/dropdown/dropdown';

// import translate from '../../utils/translate';
import { DateFormatter } from '../../utils/date';
import axios from 'axios';
import { dispatchError } from '../../actions/errors';

export class JobListItem extends Component {
	static propTypes = {
		type: PropTypes.string.isRequired,
		item: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		data: PropTypes.shape({
			updateItems: PropTypes.func.isRequired,
			dispatch: PropTypes.func.isRequired,
		}),
	};

	static defaultProps = {
		type: '',
		item: {},
	};

	render() {
		const IS_PUBLISHED = !!this.props.item.activated;
		const date = new DateFormatter(this.props.item.createdDate);
		const expireDate = new DateFormatter(date.getTime() + (90 * (24 * 60 * 60 * 1000)));
		const IS_EXPIRED = (expireDate.getTime() <= new Date().getTime());

		let profileString = '';
		let item = this.props.item;
		let { profiles } = item;


		if (profiles && profiles.name) {
			profileString += profiles.name;

			if (item.city) {
				profileString += `, ${item.city}`;
			}

			if (item.country) {
				profileString += `, ${item.country}`;
			}
		}

		return (
			<div className='editoriallist__content__item'>
				<h3 className='editoriallist__content__item__head'>{this.props.item.title}</h3>
				<span className='editoriallist__content__item__author'>{profileString}</span>
				<span className='editoriallist__content__item__foot'>
					Added: {date.monthDateAndYear}<br />
					Expires: {expireDate.monthDateAndYear}
				</span>

				{(!IS_EXPIRED) && (<a key='menu' className='editoriallist__button button button--action' ref='menu'>...</a>)}

				{(!IS_EXPIRED) && (
					<Dropdown key='dropdown' attachTo={() => this.refs.menu} pointTo='AUTO' browser={this.props.browser}>
						<ol key='dropdown-ol'>
							<li key='link-edit'><Link to={accountRoute(`/profile/jobs/${this.props.item.id}`)} onClick={this.stopPropagation}>Edit</Link></li>
							<li key='link-activate'>
								<Link to='' onClick={(e) => this.toggle(e)}>{IS_PUBLISHED ? 'Unpublish' : 'Publish'}</Link>
							</li>
						</ol>
					</Dropdown>
				)}
			</div>
		);
	}

	stopPropagation(e) {
		e.stopPropagation();
	}

	toggle(e) {
		e.preventDefault();
		e.stopPropagation();

		axios.post(`${baseUrl}/api/account/profiles/jobs/${this.props.item.id}/toggle`)
		.then((res) => {
			if (res.data && res.data.jobs && res.data.jobs.length) {
				this.props.data.updateItems(res.data.jobs);
			}
		})
		.catch((res) => {
			let msg = 'An error occurred';
			if (res.data && res.data.message) {
				msg = res.data.message;
			}

			if (this.props.data && this.props.data.dispatch) {
				this.props.data.dispatch(dispatchError(msg));
			}
		});
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jobListItem.js
 **/